<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisTabs from 'dashboard/components-next/LaisTabs.vue';
import PostSaleManagementCharts from './PostSaleManagementCharts.vue';
import PostSaleManagementDeeds from './PostSaleManagementDeeds.vue';
import PostSaleManagementQueue from './PostSaleManagementQueue.vue';

defineProps({
  activeTab: { type: String, required: true },
  dashboard: { type: Object, required: true },
  deeds: { type: Object, required: true },
  deedsLoading: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  period: { type: Object, required: true },
  queueLoading: { type: Boolean, default: false },
  queueSavingUserId: { type: [Number, String], default: null },
  queueUpdatedAt: { type: Date, default: null },
});

const emit = defineEmits([
  'changeTab',
  'openCase',
  'refreshQueue',
  'setPeriod',
  'toggleQueue',
  'viewFiltered',
]);
const { t } = useI18n();

const tabs = computed(() => [
  { id: 'graficos', label: t('POST_SALE.MANAGEMENT.CHARTS') },
  { id: 'fila', label: t('POST_SALE.MANAGEMENT.QUEUE') },
  { id: 'escrituras', label: t('POST_SALE.MANAGEMENT.DEEDS') },
]);
</script>

<template>
  <div class="flex flex-col gap-5">
    <div class="flex items-center gap-2 text-lais-text">
      <span
        class="i-lucide-house size-5 text-lais-primary"
        aria-hidden="true"
      />
      <h2 class="text-xl font-semibold">
        {{ t('POST_SALE.SECTIONS.MANAGEMENT') }}
      </h2>
    </div>

    <LaisTabs
      :model-value="activeTab"
      :tabs="tabs"
      :aria-label="t('POST_SALE.ARIA.MANAGEMENT')"
      @change="emit('changeTab', $event)"
    >
      <template #graficos>
        <PostSaleManagementCharts
          :dashboard="dashboard"
          :loading="loading"
          @view-filtered="emit('viewFiltered', $event)"
        />
      </template>

      <template #fila>
        <PostSaleManagementQueue
          :loading="queueLoading"
          :rows="dashboard.responsible_queue || []"
          :saving-user-id="queueSavingUserId"
          :updated-at="queueUpdatedAt"
          @refresh="emit('refreshQueue')"
          @toggle-queue="emit('toggleQueue', $event)"
        />
      </template>

      <template #escrituras>
        <PostSaleManagementDeeds
          :data="deeds"
          :loading="deedsLoading"
          :period="period"
          @open-case="emit('openCase', $event)"
          @set-period="emit('setPeriod', $event)"
        />
      </template>
    </LaisTabs>
  </div>
</template>
